import { uri } from '../../api-endpoint';
import {
  IKoumutenAPIValidationError,
  IKoumutenFromAPISuccessResponse
} from '../../type-conversion/koumuten/from-api-repsonse';
import { KoumutenAPIRequestBody } from '../../type-conversion/koumuten/to-api-request-body';
import { createTemplateFn } from '../common';

export const createKoumuten = (token: string) =>
  createTemplateFn(
    token,
    uri.koumutenList(),
    KoumutenAPIRequestBody,
    IKoumutenFromAPISuccessResponse,
    IKoumutenAPIValidationError
  );
